export const ClubsActions = {
  GET_CLUBS: "GET_CLUBS",
  SET_CLUBS: "SET_CLUBS",

  GET_CLUBS_DETAIL: "GET_CLUBS_DETAIL",
  SET_CLUBS_DETAIL: "SET_CLUBS_DETAIL",
};
